module.exports = function getResource(label, vars = []) {
    let resources = {
        relatedLinksLabel: 'Pages liées'
    };
    return resources[label];
};
